"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _styledSystem = require("styled-system");

var _Box = _interopRequireDefault(require("../Box/Box"));

var _Flex = _interopRequireDefault(require("../Flex/Flex"));

var _Heading = require("../Heading/Heading");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var _Paragraph = _interopRequireDefault(require("../Paragraph/Paragraph"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var expandedStyle = (0, _styledComponents.css)(["transform:rotate(180deg);"]);
var collapsedStyle = (0, _styledComponents.css)(["transform:rotate(0deg);"]);
var Wrapper = (0, _styledComponents["default"])(_Box["default"]).withConfig({
  displayName: "Accordion__Wrapper",
  componentId: "sc-1wbld61-0"
})(["border-top:", ";", ""], function (_ref) {
  var theme = _ref.theme,
      noUnderline = _ref.noUnderline;
  return noUnderline ? "none" : "1px solid " + theme.colors.dark[4];
}, _styledSystem.border);
var Header = (0, _styledComponents["default"])(_Flex["default"]).withConfig({
  displayName: "Accordion__Header",
  componentId: "sc-1wbld61-1"
})(["cursor:pointer;user-select:none;"]);
var Expander = (0, _styledComponents["default"])(_Icon["default"]).withConfig({
  displayName: "Accordion__Expander",
  componentId: "sc-1wbld61-2"
})(["transition:180ms;", ""], function (_ref2) {
  var isExpanded = _ref2.isExpanded;
  return isExpanded ? expandedStyle : collapsedStyle;
});

var Accordion = function Accordion(_ref3) {
  var children = _ref3.children,
      title = _ref3.title,
      description = _ref3.description,
      icon = _ref3.icon,
      _ref3$iconColour = _ref3.iconColour,
      iconColour = _ref3$iconColour === void 0 ? "secondary.0" : _ref3$iconColour,
      _ref3$titleColour = _ref3.titleColour,
      titleColour = _ref3$titleColour === void 0 ? "dark.1" : _ref3$titleColour,
      noUnderline = _ref3.noUnderline,
      _ref3$paddingY = _ref3.paddingY,
      paddingY = _ref3$paddingY === void 0 ? "16px" : _ref3$paddingY,
      _ref3$px = _ref3.px,
      px = _ref3$px === void 0 ? "0px" : _ref3$px,
      _ref3$outerBorder = _ref3.outerBorder,
      outerBorder = _ref3$outerBorder === void 0 ? "none" : _ref3$outerBorder,
      _ref3$fontSize = _ref3.fontSize,
      fontSize = _ref3$fontSize === void 0 ? 4 : _ref3$fontSize;

  var _useState = (0, _react.useState)(false),
      isExpanded = _useState[0],
      setIsExpanded = _useState[1];

  var toggle = function toggle() {
    return setIsExpanded(!isExpanded);
  };

  return /*#__PURE__*/_react["default"].createElement(Wrapper, {
    py: paddingY,
    width: 1 / 1,
    noUnderline: noUnderline,
    px: px,
    border: outerBorder
  }, /*#__PURE__*/_react["default"].createElement(Header, {
    alignItems: "center",
    justifyContent: "space-between",
    onClick: toggle
  }, /*#__PURE__*/_react["default"].createElement(_Box["default"], null, /*#__PURE__*/_react["default"].createElement(_Flex["default"], {
    alignItems: "center"
  }, icon && /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    name: icon,
    bg: iconColour,
    p: 20,
    borderRadius: 99,
    mr: 2,
    color: "dark.2"
  }), /*#__PURE__*/_react["default"].createElement(_Heading.H4, {
    fontSize: fontSize,
    fontWeight: "500",
    color: titleColour
  }, title)), description && /*#__PURE__*/_react["default"].createElement(_Paragraph["default"], {
    fontSize: 3,
    color: "dark.2",
    mb: 0,
    mt: 3
  }, description)), /*#__PURE__*/_react["default"].createElement(Expander, {
    name: "expand_more",
    size: 24,
    isExpanded: isExpanded,
    m: 1,
    color: "dark.2"
  })), isExpanded && /*#__PURE__*/_react["default"].createElement(_Box["default"], {
    width: 1 / 1,
    pt: 2
  }, children));
};

var _default = Accordion;
exports["default"] = _default;